import {Constants} from "../../Constants/Constant"

export function calculateTotalWeightOfOrders(arrList){
    let totalWeightOfOrders = 0
    if(arrList.length > 1){
        let sum = arrList.reduce((a,b) => ({order: {materials:{ kg: parseInt(a.order.materials.kg) + parseInt(b.order.materials.kg)}}}))
        totalWeightOfOrders = sum.order.materials.kg
    }else if(arrList.length === 1){
        totalWeightOfOrders = arrList[0].order.materials.kg
    }
    return totalWeightOfOrders
}

export const CellSettings = {}
CellSettings[Constants.internalStatus.waitingForDeparture] = {
    'internalStatusId':{ isReadOnly: false },
    'truckOrders_ewayBillNo':{ isReadOnly: false },
    'truckPlateNum':{ isReadOnly: false },
    'driver':{ isReadOnly: false },
    'fromCity':{ isReadOnly: false },
    'toCity':{ isReadOnly: false },
    'truckOrders_commitedWeight':{ isReadOnly: false },
    'truckOrders_price':{ isReadOnly: false },
    'truckOrders_status':{ isReadOnly: false },
}
CellSettings[Constants.internalStatus.onTheWayToDropCityWarehouse] = {
    'internalStatusId':{ isReadOnly: false },
    'truckOrders_ewayBillNo':{ isReadOnly: false },
    'truckPlateNum':{ isReadOnly: false },
    'driver':{ isReadOnly: false },
    'fromCity':{ isReadOnly: false },
    'toCity':{ isReadOnly: false },
    'truckOrders_commitedWeight':{ isReadOnly: false },
    'truckOrders_price':{ isReadOnly: false },
    'truckOrders_status':{ isReadOnly: false },
}
CellSettings[Constants.internalStatus.atDestinationCityWarehouse] = {
    'internalStatusId':{ isReadOnly: false },
    'truckOrders_ewayBillNo':{ isReadOnly: false },
    'truckPlateNum':{ isReadOnly: false },
    'driver':{ isReadOnly: false },
    'fromCity':{ isReadOnly: false },
    'toCity':{ isReadOnly: false },
    'truckOrders_commitedWeight':{ isReadOnly: false },
    'truckOrders_price':{ isReadOnly: false },
    'truckOrders_status':{ isReadOnly: false },
}
export const CellSettings_CityManager = {}
CellSettings_CityManager[Constants.internalStatus.waitingForDeparture] = {
    'internalStatusId':{ isReadOnly: false },
    'truckOrders_ewayBillNo':{ isReadOnly: false },
}
CellSettings_CityManager[Constants.internalStatus.onTheWayToDropCityWarehouse] = {
    'internalStatusId':{ isReadOnly: false },
}
CellSettings_CityManager[Constants.internalStatus.atDestinationCityWarehouse] = {
    'internalStatusId':{ isReadOnly: false },
}

export function hotSettingsTruckOrders(colWidths = [], self, component='hotTableComponent'){
    let hotSettings = {
        data: null,
        readOnly: true,
        hiddenColumns: {columns: []},
        fillHandle: false,
        copyPaste: false,
        licenseKey: "non-commercial-and-evaluation",
        autoRowSize: false,
        autoColumnSize: false,
        colWidths: colWidths,
        className: "htCenter htMiddle",
        filters: true,
        dropdownMenu: ['filter_by_condition', 'filter_operators', 'filter_by_condition2', 'filter_by_value', 'filter_action_bar'],
        columnSorting: { sortEmptyCells: true },
        afterChange: (changes, source) => {
            if(changes){
                changes.forEach(([row, prop, oldValue, newValue]) => {
                    let col = self.$refs[component].hotInstance.propToCol(prop)
                    if(source === 'revert' || oldValue === newValue || !newValue || self.columns[col].hasOwnProperty('component')) return
                    self.confirmObj = {row: row, prop: prop, col: col, oldValue: oldValue, newValue: newValue}
                    console.log('oldValue', oldValue, 'newValue', newValue, source)
                    self.confirmDialog = true
                });
            }
        },
    }
    return hotSettings
}

export const truckOrderObj = {
  bookingDate: 'Total',
  truckOrderNumber: '',
  internalStatusId: '',
  truckPlateNum: '',
  transporter: '',
  driver: '',
  truckOrders_ewayBillNo: 'NA',
  numOfOrders: '',
  truckOrders_commitedWeight: 'NA',
  fromCity: '',
  toCity: '',
  truckOrders_price: '',
  lrCommision: '',
  payment: '',
  truckOrders_status: '',
  orderDetailsArr: '',
  truckOrderId: '',
  internalstatus: '',
  action: 'NA'
}
